/* src/app/private/components/email-template/preview-email-template/preview-email-template.component.scss */
.right-side-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.whatsapp-ui-box {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.preview-box {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.preview-iframe {
  flex-grow: 1;
  width: 100%;
  border: none;
}
.preview-box::-webkit-scrollbar {
  width: 5px !important;
}
.preview-box::-webkit-scrollbar-thumb {
  background-color: #f5f5f5 !important;
  border-radius: 10px !important;
}
.preview-box::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.whatsapp-ui-box::-webkit-scrollbar {
  width: 5px !important;
}
.whatsapp-ui-box::-webkit-scrollbar-thumb {
  background-color: #f5f5f5 !important;
  border-radius: 10px !important;
}
.whatsapp-ui-box::-webkit-scrollbar-track {
  background-color: transparent !important;
}
/*# sourceMappingURL=preview-email-template.component.css.map */
